<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Hobo Data Upload</h2>
      <p class="tw-italic tw-text-gray-700">
        Upload hobo data to CommCare and for analysis.
      </p>
    </b-container>

    <hr />

    <b-container>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-form-file
            id="file"
            v-model="selectedFile"
            :state="Boolean(selectedFile)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            size="lg"
          ></b-form-file>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-button
            @click="onUpload()"
            variant="success"
            size="lg"
            block
          >
            Upload
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3" class="mt-3">
          <b-button
            :to="{ name: 'hobo-data' }"
            variant="warning"
            size="lg"
            block
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      selectedFile: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onFileSelected: function (event) {
      this.selectedFile = event.target.files[0];
    },
    onUpload: function () {
      const that = this;
      if (!this.selectedFile) {
        return that.$bvModal.msgBoxOk("Please select a file!", {
          title: "File Error",
          okVariant: "danger",
          centered: true,
        });
      }

      const fd = new FormData();
      fd.append("file", this.selectedFile, this.selectedFile.name);
      HTTP.post("/kenya/hobo-upload", fd)
        .then(() => {
          that.selectedFile = null;
          this.$notify({
            text: "File successfully updated!",
            duration: 10000,
            type: "success",
          });
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
  },
};
</script>

<style></style>
